import type { ReactNode } from 'react';

type Tone = 'neutral' | 'primary' | 'accent' | 'primarySolid' | 'accentSolid' | 'dark' | 'outline';

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-secondary-100 text-secondary-800',
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-900',
  primarySolid: 'bg-primary-500 text-white',
  accentSolid: 'bg-accent-500 text-white',
  dark: 'bg-foreground-900 text-foreground-50',
  outline: 'border border-secondary-300 text-secondary-700',
};

interface BadgeProps {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}

export default function Badge({ children, tone = 'neutral', className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${toneClasses[tone]} ${className}`}
    >
      {children}
    </span>
  );
}